<app-nav-menu>
  <div class="body">
    <app-location></app-location>
    <div class="container">
      <router-outlet></router-outlet>
    </div>
  </div>
</app-nav-menu>
